import React from 'react';
import { DeploymentNotifier } from '@marageti/z4-lib';
import usePusherClient from '../../hooks/use-pusher-client';
import config from '../../config';

const OryxDeploymentNotifier = () => {
  const pusherClient = usePusherClient();

  return (
    <DeploymentNotifier
      appName="oryx"
      pusherClient={pusherClient}
      channel={config.DEPLOYMENT_CHANNEL}
    />
  );
};

export default OryxDeploymentNotifier;
